
import Vue from 'vue'
import { Component, Prop, Model } from 'vue-property-decorator'

@Component<TsDatatypeSelector>({})
export default class TsDatatypeSelector extends Vue {
    @Prop({ default: [] }) public datatypes
    @Model('change') private current!: string
}
